import { t } from 'ttag'

import skillsDecoderSvg from '@h2/assets/svg/blockGraphics/skillsDecoder.svg'
import { Promotion } from '@h2/features/dashboard/promotion'

const ChooseGoalStepCard = () => {
  return (
    <Promotion color="blue" variant="continue">
      <Promotion.PreHeading>{t`Choose Your Next Task`}</Promotion.PreHeading>
      <Promotion.Heading>{t`Where are you headed to?`}</Promotion.Heading>
      <Promotion.Text>{t`As you continue progressing towards your goal, you need to select the next thing to work on.`}</Promotion.Text>
      <Promotion.Button href="/planning/goal/task">{t`Choose a Task`}</Promotion.Button>
      <Promotion.Image src={skillsDecoderSvg} />
    </Promotion>
  )
}

export { ChooseGoalStepCard }
